import API from './api.js'
import Moment from 'moment';

export default class APIList {
  constructor() {
    let api = new API();
    this.api = api;
  }

  /**
   * Start of First Class Api Management 
   */

  // Form Component API
  autoSearch(dest, paras, success, error) {
    this.api.get('/' + dest, paras,
      (json) => {
        success(json);
      },
      (err) => {
        error(err);
      }, this.api.ParseTypeEnum.json);
  }

  // getOptionByID(dest,paras,success,error){
  // this.api.get('/'+dest, paras, 
  // (json) => {
  //   success(json);
  // }, 
  // (err) => {
  //   error(err);
  // }, this.api.ParseTypeEnum.json);
  // }

  fileDelete(ID, success, error) {
    this.api.post('/dm/document/delete', { "ID": ID },
      (json) => {
        success(json);
      }, (err) => {
        error(err);
      }, this.api.ParseTypeEnum.json);
  }

  fileUpload(parameters, success, error) {
    this.api.filePost('/dm/document/upload', parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }

  fileDownload(ID) {
    // console.log('Document ID:' + ID);
    var url = this.api.domain + '/dm/document/download?ID=' + ID;
    var win = window.open(url, '_blank');
    if (win) {
      //Browser has allowed it to be opened
      win.focus();
    } else {
      //Browser has blocked it
      alert('Please allow "Popup Window" for document downloading');
    }
  }

  // Outstanding Requirement
  getOutstandingRequirement(dest, paras, success, error) {
    this.api.get('/osm/requirement' + dest, paras,
      (json) => {
        success(json);
      },
      (err) => {
        error(err);
      }, this.api.ParseTypeEnum.json);
  }


  postOutstandingRequirement(action, parameters, success, error) {
    this.api.post('/osm/requirement/' + action, parameters, (json) => {
      success(json);
    }, (err) => {
      error(err);
    }, this.api.ParseTypeEnum.json);
  }

  getAllSelections(selectionType, success, error) {
    this.api.get('/selection', [{
        "key": "type",
        "value": selectionType
      }],
      (json) => { success(json) },
      (err) => { error(err) })
  }


}



// WEBPACK FOOTER //
// ./src/api/apiList.js